<template>
    <el-container direction="vertical" class="card card-employer" v-loading="loading">
        <el-row class="pb10 card-header">
            <el-col :span="16">
                <div class="page-title bold fnt-lg dark text-left">
                    Карточка сотрудника
                </div>
                <div class="employer-id grey">
                    ID {{ employer.id }}
                </div>
            </el-col>
            <el-col :span="8" class="actions">
                <span class="action-title action-edit" @click="edit" v-if="canEdit">
                    Редактировать
                </span>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="7" justify="start">
                <el-row>
                    <el-col :span="24" class="card-general mb10">
                        <el-row class="mb25 mr15 line">
                            <el-col :span="18" class="bold fnt-mid2">
                                {{ employer.full_name }}
                            </el-col>
                            <el-col :span="6" class="text-right">
                                <div class="photo inline-block">
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="mb25">
                            <el-col :span="5">
                                <span class="bold">
                                    Офис:
                                </span>
                            </el-col>
                            <el-col :span="19">
                                {{ officeName }}
                            </el-col>
                        </el-row>
                        <el-row class="mb25">
                            <el-col :span="5">
                                <span class="bold">
                                    Должность:
                                </span>
                            </el-col>
                            <el-col :span="19">
                                {{ positionName }}
                            </el-col>
                        </el-row>
                        <el-row class="mb25">
                            <el-col :span="5">
                                <span class="bold">
                                    E-mail:
                                </span>
                            </el-col>
                            <el-col :span="19">
                                {{ employer.user.email }}
                            </el-col>
                        </el-row>
                        <el-row class="mb25">
                            <el-col :span="5">
                                <span class="bold">
                                    Телефон:
                                </span>
                            </el-col>
                            <el-col :span="19">
                                <span-mask :value="employer.phone" mask="+# (###) ###-##-##" />
                            </el-col>
                        </el-row>
                        <el-row class="mb25">
                            <el-col :span="8">
                                <span class="bold">
                                    Внутренний номер:
                                </span>
                            </el-col>
                            <el-col :span="16">
                                {{ employer.internal_number }}
                            </el-col>
                        </el-row>
                        <el-row class="mb25">
                            <el-col :span="5">
                                <span class="bold">
                                    ICQ:
                                </span>
                            </el-col>
                            <el-col :span="19">
                                {{ employer.icq }}
                            </el-col>
                        </el-row>
                        <el-row class="mb25">
                            <el-col :span="8">
                                <span class="bold">
                                    Дата увольнения:
                                </span>
                            </el-col>
                            <el-col :span="16">
                                {{ employer.date_fired }}
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="card-comment">
                        <span class="bold">
                            Комментарий:
                        </span>
                        <div v-format-text="employer.comment">
                        </div>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="16" class="card-wide">
                <div class="wrap-roles">
                    <el-row v-if="showRoles" class="roles">
                        <el-col :span="6" v-for="section in roleMaps" :key="section.title">
                            <div class="fnt-mid bold dark">
                                {{ section.title }}
                            </div>
                            <el-row>
                                <el-col :span="24" justify="start" class="mt20" v-for="subSection in section.children" :key="subSection.title">
                                    <div class="dark">
                                        {{ subSection.title }}:
                                    </div>
                                    <div class="mt20">
                                        <div v-for="role in subSection.children" :key="role.key">
                                            <div class="role" v-for="(userRole, key) in employer.user_roles" :key="key">
                                                <div v-if="userRole === role.title">
                                                    <font-awesome-icon icon="check" class="orange" />
                                                    {{ role.title }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row v-else class="margin-msg">
                        <div class="wrap-icon-text text-center fnt-lg-s2 grey">
                            Доступа к дополнительной информации нет
                        </div>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import VueTheMaskSpan from '@/components/vue-the-mask/src/component';
import '@/assets/styles/card.scss?1';

library.add(faCheck);

export default {
    name: 'EmployersCard',
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            loading: true,
            employer: {
                internal_number: null,
                user: {}
            }
        };
    },
    components: {
        spanMask: VueTheMaskSpan
    },
    beforeMount() {
        this.getEmployer();
    },
    computed: {
        roleMaps() {
            return this.$store.state.references.roles;
        },
        officeName() {
            const office = this.$store.state.references.offices.length
                ? this.$store.state.references.offices.find(office => office.id === this.employer.office_id)
                : null;
            return office ? office.name : '';
        },
        positionName() {
            const position = this.$store.state.references.positions.length
                ? this.$store.state.references.positions.find(position => position.id === this.employer.position_id)
                : null;
            return position ? position.name : '';
        },
        showRoles() {
            return this.$store.state.auth.roles.right_setup;
        },
        canEdit() {
            const roles = this.$store.state.auth.roles;
            const approvedRoles = ['office_manager', 'head_office', 'right_setup'];
            const intersection = Object.keys(roles).filter(x => approvedRoles.includes(x));

            return intersection.length > 0;
        }
    },
    methods: {
        async getEmployer() {
            try {
                const response = await this.$store.dispatch('employers/getEmployer', this.id);
                this.employer = response.data.data;
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        },
        edit() {
            if (this.canEdit) {
                this.$router.push({ name: 'employer-card-edit', params: { id: '' + this.id } });
            }
        },
        close() {
            this.$router.push({ name: 'employers' });
        }
    }
};
</script>
